export default [
    {"label": "Polska", "value": "PL"},
    {"label": "Niemcy", "value": "DE"},
    {"label": "Wielka Brytania", "value": "GB"},
    {"label": "Afganistan", "value": "AF"},
    {"label": "Albania", "value": "AL"},
    {"label": "Algieria", "value": "DZ"},
    {"label": "Andora", "value": "AD"},
    {"label": "Angola", "value": "AO"},
    {"label": "Anguilla", "value": "AI"},
    {"label": "Antarktyka", "value": "AQ"},
    {"label": "Antigua i Barbuda", "value": "AG"},
    {"label": "Arabia Saudyjska", "value": "SA"},
    {"label": "Argentyna", "value": "AR"},
    {"label": "Armenia", "value": "AM"},
    {"label": "Aruba", "value": "AW"},
    {"label": "Australia", "value": "AU"},
    {"label": "Austria", "value": "AT"},
    {"label": "Azerbejdżan", "value": "AZ"},
    {"label": "Bahamy", "value": "BS"},
    {"label": "Bahrajn", "value": "BH"},
    {"label": "Bangladesz", "value": "BD"},
    {"label": "Barbados", "value": "BB"},
    {"label": "Belgia", "value": "BE"},
    {"label": "Belize", "value": "BEBJ"},
    {"label": "Benin", "value": "BM"},
    {"label": "Bermudy", "value": "BT"},
    {"label": "Bhutan", "value": "BY"},
    {"label": "Białoruś", "value": "BO"},
    {"label": "Boliwia", "value": "BQ"},
    {"label": "Bonaire, Sint Eustatius i Saba", "value": "BA"},
    {"label": "Bośnia i Hercegowina", "value": "BW"},
    {"label": "Botswana", "value": "BR"},
    {"label": "Brazylia", "value": "BN"},
    {"label": "Brunei", "value": "IO"},
    {"label": "Brytyjskie Terytorium Oceanu Indyjskiego", "value": "VG"},
    {"label": "Brytyjskie Wyspy Dziewicze", "value": "BG"},
    {"label": "Bułgaria", "value": "BF"},
    {"label": "Burkina Faso", "value": "BI"},
    {"label": "Burundi", "value": "CL"},
    {"label": "Chile", "value": "CN"},
    {"label": "Chiny", "value": "HR"},
    {"label": "Chorwacja", "value": "CW"},
    {"label": "Curaçao", "value": "CY"},
    {"label": "Cypr", "value": "TD"},
    {"label": "Czad", "value": "ME"},
    {"label": "Czarnogóra", "value": "CZ"},
    {"label": "Czechy", "value": "UM"},
    {"label": "Dalekie Wyspy Mniejsze Stanów Zjednoczonych", "value": "DK"},
    {"label": "Dania", "value": "CD"},
    {"label": "Demokratyczna Republika Konga", "value": "DM"},
    {"label": "Dominika", "value": "DO"},
    {"label": "Dominikana", "value": "DJ"},
    {"label": "Dżibuti", "value": "EG"},
    {"label": "Egipt", "value": "EC"},
    {"label": "Ekwador", "value": "ER"},
    {"label": "Erytrea", "value": "EE"},
    {"label": "Estonia", "value": "SZ"},
    {"label": "Eswatini", "value": "ET"},
    {"label": "Etiopia", "value": "FK"},
    {"label": "Falklandy", "value": "FJ"},
    {"label": "Fidżi", "value": "PH"},
    {"label": "Filipiny", "value": "FI"},
    {"label": "Finlandia", "value": "FR"},
    {"label": "Francja", "value": "TF"},
    {"label": "Francuskie Terytoria Południowe i Antarktyczne", "value": "GA"},
    {"label": "Gabon", "value": "GM"},
    {"label": "Gambia", "value": "GS"},
    {"label": "Georgia Południowa i Sandwich Południowy", "value": "GH"},
    {"label": "Ghana", "value": "GI"},
    {"label": "Gibraltar", "value": "GR"},
    {"label": "Grecja", "value": "GD"},
    {"label": "Grenada", "value": "GL"},
    {"label": "Grenlandia", "value": "GE"},
    {"label": "Gujana Francuska", "value": "GU"},
    {"label": "Guam", "value": "GG"},
    {"label": "Guernsey", "value": "GF"},
    {"label": "Gujana", "value": "GY"},
    {"label": "Gujana", "value": "GP"},
    {"label": "Gwadelupa", "value": "GT"},
    {"label": "Gwatemala", "value": "GW"},
    {"label": "Gwinea Bissau", "value": "GQ"},
    {"label": "Gwinea Równikowa", "value": "GN"},
    {"label": "Gwinea", "value": "HT"},
    {"label": "Haiti", "value": "ES"},
    {"label": "Hiszpania", "value": "NL"},
    {"label": "Holandia", "value": "HN"},
    {"label": "Honduras", "value": "HK"},
    {"label": "Hongkong", "value": "IN"},
    {"label": "Indie", "value": "ID"},
    {"label": "Indonezja", "value": "IQ"},
    {"label": "Irak", "value": "IR"},
    {"label": "Iran", "value": "IE"},
    {"label": "Irlandia", "value": "IS"},
    {"label": "Islandia", "value": "IL"},
    {"label": "Izrael", "value": "JM"},
    {"label": "Jamajka", "value": "JP"},
    {"label": "Japonia", "value": "YE"},
    {"label": "Jemen", "value": "JE"},
    {"label": "Jersey", "value": "JO"},
    {"label": "Jordania", "value": "KY"},
    {"label": "Kajmany", "value": "KH"},
    {"label": "Kambodża", "value": "CM"},
    {"label": "Kamerun", "value": "CA"},
    {"label": "Kanada", "value": "QA"},
    {"label": "Katar", "value": "KZ"},
    {"label": "Kazachstan", "value": "KE"},
    {"label": "Kenia", "value": "KG"},
    {"label": "Kirgistan", "value": "KI"},
    {"label": "Kiribati", "value": "CO"},
    {"label": "Kolumbia", "value": "KM"},
    {"label": "Komory", "value": "CG"},
    {"label": "Kongo", "value": "KR"},
    {"label": "Korea Południowa", "value": "KP"},
    {"label": "Korea Północna", "value": "CR"},
    {"label": "Kostaryka", "value": "CU"},
    {"label": "Kuba", "value": "KW"},
    {"label": "Kuwejt", "value": "LA"},
    {"label": "Laos", "value": "LS"},
    {"label": "Lesotho", "value": "LB"},
    {"label": "Liban", "value": "LR"},
    {"label": "Liberia", "value": "LY"},
    {"label": "Libia", "value": "LI"},
    {"label": "Liechtenstein", "value": "LT"},
    {"label": "Litwa", "value": "LU"},
    {"label": "Luksemburg", "value": "LV"},
    {"label": "Łotwa", "value": "MK"},
    {"label": "Macedonia", "value": "MG"},
    {"label": "Madagaskar", "value": "YT"},
    {"label": "Majotta", "value": "MO"},
    {"label": "Makau", "value": "MW"},
    {"label": "Malawi", "value": "MV"},
    {"label": "Malediwy", "value": "MY"},
    {"label": "Malezja", "value": "ML"},
    {"label": "Mali", "value": "MT"},
    {"label": "Malta", "value": "MP"},
    {"label": "Mariany Północne", "value": "MA"},
    {"label": "Maroko", "value": "MQ"},
    {"label": "Martynika", "value": "MR"},
    {"label": "Mauretania", "value": "MU"},
    {"label": "Mauritius", "value": "MX"},
    {"label": "Meksyk", "value": "FM"},
    {"label": "Mikronezja", "value": "MM"},
    {"label": "Mjanma", "value": "MD"},
    {"label": "Mołdawia", "value": "MC"},
    {"label": "Monako", "value": "MN"},
    {"label": "Mongolia", "value": "MS"},
    {"label": "Montserrat", "value": "MZ"},
    {"label": "Mozambik", "value": "NA"},
    {"label": "Namibia", "value": "NR"},
    {"label": "Nauru", "value": "NP"},
    {"label": "Nepal", "value": "DE"},
    {"label": "Niger", "value": "NG"},
    {"label": "Nigeria", "value": "NI"},
    {"label": "Nikaragua", "value": "NU"},
    {"label": "Niue", "value": "NF"},
    {"label": "Norfolk", "value": "NO"},
    {"label": "Norwegia", "value": "NC"},
    {"label": "Nowa Kaledonia", "value": "NZ"},
    {"label": "Nowa Zelandia", "value": "OM"},
    {"label": "Oman", "value": "PK"},
    {"label": "Pakistan", "value": "PW"},
    {"label": "Palau", "value": "PS"},
    {"label": "Palestyna", "value": "PA"},
    {"label": "Panama", "value": "PG"},
    {"label": "Papua-Nowa Gwinea", "value": "PY"},
    {"label": "Paragwaj", "value": "PE"},
    {"label": "Peru", "value": "PN"},
    {"label": "Pitcairn", "value": "PF"},
    {"label": "Polinezja Francuska", "value": "PL"},
    {"label": "Portoryko", "value": "PT"},
    {"label": "Południowa Afryka", "value": "ZA"},
    {"label": "Republika Środkowoafrykańska", "value": "CF"},
    {"label": "Republika Zielonego Przylądka", "value": "CV"},
    {"label": "Reunion", "value": "RE"},
    {"label": "Rosja", "value": "RU"},
    {"label": "Rumunia", "value": "RO"},
    {"label": "Rwanda", "value": "RW"},
    {"label": "Sahara Zachodnia", "value": "EH"},
    {"label": " Saint Kitts i Nevis", "value": "KN"},
    {"label": "Saint Lucia", "value": "LN"},
    {"label": "Saint Vincent i Grenadyny", "value": "VC"},
    {"label": "Saint-Barthélemy", "value": "BL"},
    {"label": "Saint-Martin", "value": "MF"},
    {"label": "Saint-Pierre i Miquelon", "value": "PM"},
    {"label": "Salwador", "value": "SV"},
    {"label": "Samoa Amerykańskie", "value": "AS"},
    {"label": "Samoa", "value": "WS"},
    {"label": "San Marino", "value": "SM"},
    {"label": "Senegal", "value": "SN"},
    {"label": "Serbia", "value": "RS"},
    {"label": "Seszele", "value": "SC"},
    {"label": "Sierra Leone", "value": "SL"},
    {"label": "Singapur", "value": "SG"},
    {"label": "Sint Maarten", "value": "SX"},
    {"label": "Słowacja", "value": "SK"},
    {"label": "Słowenia", "value": "SI"},
    {"label": "Somalia", "value": "SO"},
    {"label": "Sri Lanka", "value": "LK"},
    {"label": "Stany Zjednoczone", "value": "US"},
    {"label": "Sudan", "value": "SD"},
    {"label": "Sudan Południowy", "value": "SS"},
    {"label": "Surinam", "value": "SR"},
    {"label": "Svalbard i Jan Mayen", "value": "SJ"},
    {"label": "Syria", "value": "SY"},
    {"label": "Szwajcaria", "value": "CH"},
    {"label": "Szwecja", "value": "SE"},
    {"label": "Tadżykistan", "value": "TJ"},
    {"label": "Tajlandia", "value": "TH"},
    {"label": "Tajwan", "value": "TW"},
    {"label": "Tanzania", "value": "TZ"},
    {"label": "Timor Wschodni", "value": "TL"},
    {"label": "Togo", "value": "TG"},
    {"label": "Tokelau", "value": "TK"},
    {"label": "Tonga", "value": "TO"},
    {"label": "Trynidad i Tobago", "value": "TT"},
    {"label": "Tunezja", "value": "TN"},
    {"label": "Turcja", "value": "TR"},
    {"label": "Turkmenistan", "value": "TM"},
    {"label": "Turks i Caicos", "value": "TC"},
    {"label": "Tuvalu", "value": "TV"},
    {"label": "Uganda", "value": "UG"},
    {"label": "Ukraina", "value": "UA"},
    {"label": "Urugwaj", "value": "UY"},
    {"label": "Uzbekistan", "value": "UZ"},
    {"label": "Vanuatu", "value": "VU"},
    {"label": "Wallis i Futuna", "value": "WF"},
    {"label": "Watykan", "value": "VA"},
    {"label": "Wenezuela", "value": "VE"},
    {"label": "Węgry", "value": "HU"},
    {"label": "Wietnam", "value": "VN"},
    {"label": "Włochy", "value": "IT"},
    {"label": "Wybrzeże Kości Słoniowej", "value": "CI"},
    {"label": "Wyspa Bouveta", "value": "BV"},
    {"label": "Wyspa Bożego Narodzenia", "value": "CX"},
    {"label": "Wyspa Man", "value": "IM"},
    {"label": "Wyspa Świętej Heleny", "value": "SH"},
    {"label": "Wyspy Alandzkie", "value": "AX"},
    {"label": "Wyspy Cooka", "value": "CK"},
    {"label": "Wyspy Dziewicze Stanów Zjednoczonych", "value": "VI"},
    {"label": "Wyspy Heard i McDonalda", "value": "HM"},
    {"label": "Wyspy Kokosowe", "value": "CC"},
    {"label": "Wyspy Marshalla", "value": "MH"},
    {"label": "Wyspy Owcze", "value": "FO"},
    {"label": "Wyspy Salomona", "value": "SB"},
    {"label": "Wyspy Świętego Tomasza i Książęca", "value": "ST"},
    {"label": "Zambia", "value": "ZM"},
    {"label": "Zimbabwe", "value": "ZW"},
    {"label": "Zjednoczone Emiraty Arabskie", "value": "AE"},
]

